import { Api, apiMixin, ConfigHelper } from 'relapp-api';
import { EventBus } from 'relapp-event';
import store from '@/store/index.js';

const userRoutes = ConfigHelper.entityApiRoutes('users');

export default {
    /**
     * Call the login endpoint.
     *
     * @param {object} form
     *
     * @return {Promise}
     */
    login(form) {
        return form
            .submit('post', ConfigHelper.apiUrl('login'))
            .then(data => {
                store.dispatch('user/login', {
                    user: data.user,
                    availableActions: data.available_actions,
                    chat: data.chat
                });
            })
            .catch(apiMixin.methods.handleError);
    },
    /**
     * Call the logout endpoint.
     *
     * @return {Promise}
     */
    logout() {
        return Api.post(ConfigHelper.apiUrl('logout'));
    },
    /**
     * Call the register endpoint.
     *
     * @param {array} data
     *
     * @return {Promise}
     */
    register(data) {
        return Api.post(ConfigHelper.apiUrl('register'), data).then(response => {
            if (response.data.hasOwnProperty('user')) {
                store.dispatch('user/setUser', response.data.user);
            }
            if (response.data.hasOwnProperty('available_actions')) {
                store.dispatch('user/setAvailableActions', response.data.available_actions);
            }
        });
    },
    /**
     * Call the set password endpoint.
     *
     * @param {object} form
     *
     * @return {Promise}
     */
    setPassword(form) {
        return form.submit('post', ConfigHelper.apiUrl('set-password'));
    },
    /**
     * Call the reset password endpoint.
     *
     * @param {object} form
     *
     * @return {Promise}
     */
    resetPassword(form) {
        return form.submit('post', ConfigHelper.apiUrl('reset-password'));
    },
    /**
     * Call the reset password email endpoint.
     *
     * @param {object} form
     *
     * @return {Promise}
     */
    resetPasswordEmail(form) {
        return form.submit('post', ConfigHelper.apiUrl('reset-password-email'));
    },
    /**
     * Call the login as endpoint.
     *
     * @param {string} token
     * @param {number} userId
     *
     * @return {Promise}
     */
    loginAs({ token, userId }) {
        return Api.post(
            ConfigHelper.apiUrl('login-as', [
                {
                    key: '{user}',
                    value: userId
                }
            ]),
            {
                token
            }
        )
            .then(({ data }) => {
                store.dispatch('user/login', {
                    user: data.user,
                    originalUser: data.original_user,
                    availableActions: data.available_actions,
                    chat: data.chat
                });
            })
            .catch(error => {
                if (error.data) {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: error.data.message
                    });
                }

                apiMixin.methods.handleError.handleError(error);
            });
    },

    /**
     * Call get current user endpoint so we get again the current user data.
     *
     * @return {Promise}
     */
    reloadUser() {
        let route = userRoutes['current-user'];

        return Api.get(route)
            .then(response => {
                store.dispatch('user/setUser', response.data.data);

                EventBus.$emit('route', {
                    name: 'services'
                });

                return response;
            })
            .catch(() => {
                store.dispatch('user/logout');
            });
    }
};
